import React, { Component } from "react";
import TableEcritures from "../../../components/TableEcritures/index";
import { connect } from "react-redux";

import {
  saveEcriture,
  updateEcriture,
  deleteEcriture,
  loadEcritures,
} from "../../../store/actions/ecritureAction";
import { Spin } from "antd";

class Recherche extends Component {
  componentDidMount() {
    this.props.loadEcritures();
  }

  render() {
    const { utilisateur, ecritures } = this.props;

    return (
      <Spin size="large" tip="Chargement en cours..." spinning={!ecritures}>
        <div style={{ padding: 10 }}>
          <TableEcritures
            utilisateur={utilisateur}
            ecritures={ecritures}
            saveEcriture={this.props.saveEcriture}
            addPanesEcriture={this.props.addPanesEcriture}
          />
        </div>
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadEcritures: () => dispatch(loadEcritures()),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
    updateEcriture: (ecriture, id) => dispatch(updateEcriture(ecriture, id)),
    deleteEcriture: (id) => dispatch(deleteEcriture(id)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    ecritures: state.ecritures.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Recherche);
